import React, { memo } from "react"
import { Link } from "react-router-dom"
import ApolloClient from "apollo-client"
import { NormalizedCacheObject } from "apollo-cache-inmemory"
import Avatar from "src/components/avatar"
import { images } from "src/assets"
import { timeStampTo_M_Day } from "src/dashboards/components/stamptime-converter"
import AuthenticationState from "src/hoc/authentication/authentication.state"
import "./style.scss"
import { Helmet } from "react-helmet-async"
import {
  CardWrapper,
  ImageContainer,
  UserAvatarContainer,
  TextContainer,
  Content,
  Text,
  Name,
  Detail,
  Heading1,
  ReadMore,
  Subheading,
  Date,
  BlogsImage,
  TagContainer,
  TagsList
} from "./UI"
import { DescText } from "src/containers/single-help-article"
import { DEFAULT_SPACE_PICTURE } from "src/config/constants"
import { BolgListType } from "src/containers/single-blog"

interface Props {
  list: BolgListType
  authState: AuthenticationState
  client: ApolloClient<NormalizedCacheObject>
  height?: string
  tabHeight?: string
}

const CardComponent = ({ list, height = "31rem", tabHeight = "24.5rem" }: Props) => {
  const { title, user, description, createdAt, id, thumbnailUrl, tag } = list
  const date = timeStampTo_M_Day(createdAt)

  return (
    <>
      <Helmet>
        <title>Tolobi Blog - Explore Insights & Tips on Renting in Canada</title>
        <meta
          name="description"
          content="Get the latest updates, along with expert insights and valuable tips with the Tolobi Blogs. Stay ahead of the game with our informative articles on renting in Canada."
        />
        <link rel="canonical" href={window?.location?.href} />
      </Helmet>
      <CardWrapper height={height} tabHeight={tabHeight}>
        <ImageContainer>
          <Link to={{
            pathname: `/blog/${id}/${title
              .toLowerCase()
              .trim()
              .replace(/[^\w\s-]/g, "")
              .replace(/[\s_-]+/g, "-")
              .replace(/^-+|-+$/g, "")}`
          }}
            target="_blank"
            rel="noreferrer">
            <BlogsImage
              src={(thumbnailUrl && thumbnailUrl) || images.imgCard}
              placeholder={DEFAULT_SPACE_PICTURE}
            />
          </Link>
          <UserAvatarContainer>
            <Avatar
              size="blog"
              imageURL={(user && user.avatarUrl) || "/images/default-profile-picture.png"}
            />
          </UserAvatarContainer>
        </ImageContainer>
        <TextContainer>
          <Content>
            <Detail>
              <Text>
                <Name>
                  {user && user.firstName} {user && user.lastName}&nbsp; &nbsp;
                </Name>
                <Date> {date}</Date>
              </Text>
              {/* <LikeUnlike authState={authState} list={list} client={client} /> */}
            </Detail>
            <Heading1><Link className="blog_link" to={{
              pathname: `/blog/${id}/${title
                .toLowerCase()
                .trim()
                .replace(/[^\w\s-]/g, "")
                .replace(/[\s_-]+/g, "-")
                .replace(/^-+|-+$/g, "")}`
            }}
              target="_blank"
              rel="noreferrer">{title}</Link></Heading1>
            <Subheading>
              <DescText
                dangerouslySetInnerHTML={{ __html: description?.split("<img")[0] }}
              ></DescText>
            </Subheading>
            {tag ? (
              <TagContainer>
                {tag?.map(item => {
                  return <TagsList key={item.name}>{item.name}</TagsList>
                })}
              </TagContainer>
            ) : null}
          </Content>
          <Link
            to={{
              pathname: `/blog/${id}/${title
                .toLowerCase()
                .trim()
                .replace(/[^\w\s-]/g, "")
                .replace(/[\s_-]+/g, "-")
                .replace(/^-+|-+$/g, "")}`
            }}
            target="_blank"
            rel="noreferrer"
          >
            <ReadMore>Read More</ReadMore>
          </Link>
        </TextContainer>
      </CardWrapper>
    </>
  )
}

export default memo(CardComponent)
